module.exports = __webpack_public_path__ + "img/experience01.6405aa6e.png";